import { matchPath } from "react-router";

const TELEPHONIST_SERVICE_BAN_PATHS = [
  "/contact-center/agent-group",
  "/mini-crm/topic",
  "/cloud-pbx/number",
  "/monitor/sumary",
];

export const checkIsAllowedPath = (role) => {
  if (role === "telephonist.service") {
    return TELEPHONIST_SERVICE_BAN_PATHS.every(
      (banPath) =>
        !matchPath(window.location.pathname, {
          path: `${process.env.REACT_APP_PATH}${banPath}`,
        })
    );
  }

  return true;
};
